<template>
  <div class="swiper-img">
    <swiper class="shorex-banner" :options="swiperOptions" ref="bannerSwiper" @slide-change-transition-end="onSlideChange()">
      <swiper-slide v-for="(item, j) in bannerList" :key="j">
          <div v-if="item.wechatMiniProgramBannerImage" style="width: 100%;height: 100%">
            <img v-if="item.bannerType===0" :src="item.wechatMiniProgramBannerImage" alt="">
            <DestinationVideo v-else :videoUrl="item.wechatMiniProgramBannerImage"
                              :coverUrl="item.wechatVideoImage"
                              @onChangeVideo="onChangeVideoPlay"
                              :shorexBannerIndex="`${shorexIndex}_${j}`"/>
          </div>
      </swiper-slide>
    </swiper>
    <div class="swiper-dots" v-if="bannerList.length>1 && isShowIndication">
    <span id="cruiseDetailBannerIndex"
          class="dots-item"
          :class="{'active': idx === swiperIndex}"
          v-for="(x,idx) in bannerList"
          :key="idx">
    </span>
    </div>
  </div>
</template>
<script>
import DestinationVideo from "@/components/DestinationVideo.vue";
// import 'swiper/css/swiper.css'
export default {
  name: "shoreSightseeSwiper",
  components: {
    DestinationVideo,
  },
  props: {
    bannerList: {
      type: Array,
      default() {
        return []
      }
    },
    shorexIndex:{
      type: Number,
      default: 0
    },
    isShowIndication:{
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      swiperOptions: {
        loop: false,
        speed: 500,
        autoplay: false,
      },
      swiperIndex: 0,
      bannerIndex:0
    }
  },
  methods: {
    onSlideChange() {
      let swiper = this.$refs.bannerSwiper.swiper
      this.swiperIndex = swiper.realIndex
    },
    onChangeVideoPlay(){
      let swiper = this.$refs.bannerSwiper.swiper
      swiper.autoplay.stop()
    }
  }
}
</script>
<style scoped lang="less">
.swiper-img {
  position: relative;
  width: 100%;
  height: 100%;
  & .shorex-banner{
    width: 100%;
    height: 100%;
    position: relative;
    img{
      width: 100%;
      height: 100%;
    }

  }
  & .swiper-btn-right {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translate(0, -50%);
    cursor: pointer;
    z-index: 9;
    width: 30px;
    height: 50px;
  }

  & .swiper-btn-left {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translate(0, -50%);
    cursor: pointer;
    z-index: 9;
    width: 30px;
    height: 50px;
  }
  img {
    width: 100%;
    height: 100%;
    display: block;
  }

}
& .swiper-dots{
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  & .dots-item{
    width: 16px;
    height: 16px;
    background: #fff;
    border-radius: 50%;
  }
  & .dots-item.active{
    background: #e3b340;
  }
}
</style>